import { Component } from '@angular/core';
import { APP_CONFIG } from  '../../../../../appConfig'
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-footer',
  imports: [RouterModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  appConfig = APP_CONFIG;
}
